// A time group fans out across courts, locations, or both. The chip always
// labels availability rather than naming a court: the court is never the thing
// being chosen on the chip (that happens in the picker), and when the service
// assigns it the name must not leak at all. `showLocation` is on only for
// multi-branch clubs, where naming the single branch behind a group is useful
// rather than noise. `showDuration` (the "All durations" filter) leads with
// the lengths on offer at this time — "60–120 min · 3 courts".
export function getOptionsLabel(slots, showLocation = false, showDuration = false) {
  const courts = new Set(slots.map((s) => s.facilityId).filter(Boolean));
  const locations = new Set(slots.map((s) => s.locationId).filter(Boolean));
  const prefix = showDuration ? `${durationRangeLabel(slots)} · ` : "";

  if (locations.size > 1) return `${prefix}${locations.size} locations`;

  const count = courts.size || slots.length;
  const label = `${prefix}${count} ${count === 1 ? "court" : "courts"}`;
  const locationName = slots[0]?.locationName;
  return showLocation && locationName ? `${label} · ${locationName}` : label;
}

// "60 min" for one length, "60–120 min" for several.
export function durationRangeLabel(slots) {
  const ds = [...new Set(slots.map((s) => parseInt(s.duration, 10)).filter(Number.isInteger))].sort((a, b) => a - b);
  if (!ds.length) return "";
  return ds.length === 1 ? `${ds[0]} min` : `${ds[0]}–${ds[ds.length - 1]} min`;
}

// One entry per location, each keeping its own slots. Used when the court is
// assigned but several branches offer the time — the branch is still a choice.
export function groupSlotsByLocation(slots) {
  const byLocation = new Map();
  for (const slot of slots || []) {
    if (!byLocation.has(slot.locationId)) {
      byLocation.set(slot.locationId, { locationId: slot.locationId, locationName: slot.locationName, slots: [] });
    }
    byLocation.get(slot.locationId).slots.push(slot);
  }
  return Array.from(byLocation.values());
}

// A court move found nothing: say why (only times at the price paid are offered).
export function rescheduleEmptyProps({ week = false, onNext }) {
  return {
    title: `No times to move to ${week ? "this week" : "on this day"}`,
    description: `Your court can move to any time a court is free, at the same price you paid. Try another ${week ? "week" : "day"} or location.`,
    actionLabel: week ? "Next week" : "Try tomorrow",
    onAction: onNext
  };
}
